import { connect } from 'react-redux'
import { reduxForm } from 'redux-form/immutable'
import { createStructuredSelector } from 'reselect'

import { getIdentityActiveProTrackName } from 'store/entities/identity/selectors'
import { unsubscribeProgress } from 'store/entities/identity/actions'
import WhyYouStopOrChangeProTrackPopup from 'app/domains/common/WhyYouStopOrChangeProTrackPopup'
import { WHY_YOU_STOP_PROTRACK_FORM_NAME } from 'app/constants/profile'

const mapStateToProps = createStructuredSelector({
  selectedProTrackName: getIdentityActiveProTrackName,
})

const mapDispatchToProps = {
  onSubmit: data => unsubscribeProgress({ data, formName: WHY_YOU_STOP_PROTRACK_FORM_NAME }),
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: WHY_YOU_STOP_PROTRACK_FORM_NAME,
    destroyOnUnmount: false,
  })(WhyYouStopOrChangeProTrackPopup)
)
